module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-logo"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('img', {
    attrs: {
      "src": _vm.logourl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "top": "14px",
      "font-size": "25px",
      "font-weight": "bolder"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.slogan) + "\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apps"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/wechat.jpg",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("友云采公众号")]), _vm._v(" "), _c('img', {
    staticClass: "hideimg",
    attrs: {
      "src": "static/imgs/supplier.png",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hideimg"
  }, [_vm._v("供应商App")]), _vm._v(" "), _c('img', {
    staticClass: "hideimg",
    attrs: {
      "src": "static/imgs/purchaser.png",
      "alt": "",
      "width": "70px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hideimg"
  }, [_vm._v("采购商App")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group pull-right hidden"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜索商机/物资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/search.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26c5b121","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-logo.vue
// module id = 17
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15 16 17